export default {
  path: '/client-portal',
  component: () => import(/* webpackChunkName: "clients-portal" */ './layout.vue'),
  children: [
    {
      path: '/',
      name: 'client-portal.login',
      component: () => import(/* webpackChunkName: "clients-portal" */ './login.vue'),
      meta: {
        auth: 'guest',
      },
    },
    {
      name: 'client-portal.register',
      path: 'register',
      component: () => import(/* webpackChunkName: "clients-portal" */ './register.vue'),
      meta: {
        auth: 'guest',
      },
    },
    {
      path: 'profile',
      name: 'client-portal.profile',
      component: () => import(/* webpackChunkName: "clients-portal" */ './profile.vue'),
      meta: {
        auth: 'guest',
      },
    },
    {
      path: 'verifyEmail',
      name: 'client-portal.verifyEmail',
      component: () => import(/* webpackChunkName: "clients-portal" */ './verifyEmail.vue'),
      meta: {
        auth: 'guest',
      },
    },
  ],
};
